import { type CSSProperties } from 'typestyle/lib/types';
import DashboardTheme from '../statistics/dashboard/dashboard-theme';

// The office detail page reuses the statistics dashboard's tab chrome (same tokens, same
// underline-on-active treatment) so both admin sections read as one design system.
export const pageTitle: CSSProperties = {
  fontFamily: DashboardTheme.headerFontFamily,
  fontSize: 22,
  fontWeight: 700,
  letterSpacing: '-0.01em',
  color: DashboardTheme.navy900,
  margin: '0 0 3px 0',
  wordBreak: 'break-word',
};

export const pageSub: CSSProperties = {
  fontFamily: DashboardTheme.bodyFontFamily,
  color: DashboardTheme.gray700,
  fontSize: 13.5,
  margin: '0 0 4px 0',
};

export const tabBar = (isMobile: boolean): CSSProperties => ({
  display: 'flex',
  gap: isMobile ? 14 : 26,
  borderBottom: `1px solid ${DashboardTheme.gray200}`,
  margin: '14px 0 8px',
  flexWrap: 'wrap',
  fontFamily: DashboardTheme.bodyFontFamily,
});

export const tab = (active: boolean): CSSProperties => ({
  padding: '10px 4px',
  cursor: 'pointer',
  fontSize: 13.5,
  fontWeight: 600,
  color: active ? DashboardTheme.navy800 : DashboardTheme.gray500,
  borderBottom: active ? `2px solid ${DashboardTheme.amber500}` : '2px solid transparent',
  whiteSpace: 'nowrap',
  transition: 'color .12s ease',
});

// Tab panels are kept mounted and hidden (not unmounted) so switching tabs never loses
// half-finished edits or triggers a refetch — same technique as the statistics page.
export const hiddenPanel: CSSProperties = {
  display: 'none',
};

// Access tab: the permitted-users table needs the width, the administrators list is a short
// column of e-mail chips — 70/30 on desktop, stacked on mobile.
export const accessGrid = (isMobile: boolean): CSSProperties => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 7fr) minmax(0, 3fr)',
  gap: isMobile ? 0 : 24,
  alignItems: 'start',
});
